import React from 'react';

const block = 'bg-gray-200 dark:bg-slate-700 rounded';
const soft = 'bg-gray-100 dark:bg-slate-800 rounded';

const ColumnSkeleton: React.FC<{ rows: number }> = ({ rows }) => (
    <div className="rounded-xl border border-gray-200 dark:border-slate-700 bg-white dark:bg-slate-800 p-4 space-y-3">
        <div className={`${block} h-4 w-40`} />
        <div className={`${soft} h-3 w-28`} />
        <div className="pt-2 space-y-2">
            {Array.from({ length: rows }).map((_, i) => (
                <div key={i} className={`${soft} h-4 w-full`} />
            ))}
        </div>
    </div>
);

const RoutingViewSkeleton: React.FC = () => (
    <div className="py-4 flex flex-col gap-4 animate-pulse">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-3">
            {Array.from({ length: 4 }).map((_, i) => (
                <div key={i} className="rounded-xl border border-gray-200 dark:border-slate-700 bg-white dark:bg-slate-800 px-4 py-3 space-y-2">
                    <div className={`${soft} h-3 w-24`} />
                    <div className={`${block} h-4 w-32`} />
                </div>
            ))}
        </div>
        <div className="flex gap-4 border-b border-gray-200 dark:border-slate-700 pb-2">
            {Array.from({ length: 3 }).map((_, i) => (
                <div key={i} className={`${soft} h-4 w-28`} />
            ))}
        </div>
        <div className="grid grid-cols-3 gap-10 mt-2">
            <ColumnSkeleton rows={6} />
            <ColumnSkeleton rows={8} />
            <ColumnSkeleton rows={6} />
        </div>
    </div>
);

export default RoutingViewSkeleton;
